import { Injectable } from "@angular/core";
import { AuthService } from "../../shared/services/auth.service";
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from "@angular/common/http";
import { TransactionService } from "./transaction.service";
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private transactionService: TransactionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const currentDate = new Date();
    // Get the auth token from the service.
    const authToken = this.auth.getToken();
    const userId = this.auth.getUser()?.id ?? 0;
    const userDate = `${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
    const transactionId = this.transactionService.getTransactionId();

    let headers = req.headers
    .set("Authorization", `Bearer ${authToken}`)
    .set('loggedInUserId', userId.toString())
    .set('loggedInUserDate', userDate)
    .set('transactionId', transactionId ?? '');

    // Only add transactionId if it exists
    // if (transactionId) {
    //   console.log('transactionId hit', transactionId);
    //   headers = headers.set('transactionId', transactionId);
    // }

    const authReq = req.clone({ headers });

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
